module.exports = __webpack_public_path__ + "media/images/illustrations/clutter_truck-18958323c20163d906570173503f9104.svg";